import { Routes } from '@angular/router';
import { authGuard, loginGuard, superAdminGuard, themeEditorCanDeactivateGuard } from './core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./layouts/public-layout/public-layout.component').then(m => m.PublicLayoutComponent),
    canActivate: [loginGuard]
  },
  {
    path: 'accept-invitation',
    loadComponent: () => import('./features/public/accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent)
  },
  {
    path: 'admin',
    loadComponent: () => import('./layouts/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'clients',
        loadComponent: () => import('./features/admin/clients/clients.component').then(m => m.ClientsComponent),
        canActivate: [superAdminGuard]
      },
      {
        path: 'users',
        loadComponent: () => import('./features/admin/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'themes',
        loadComponent: () => import('./features/admin/themes/themes.component').then(m => m.ThemesComponent),
        canDeactivate: [themeEditorCanDeactivateGuard]
      },
      {
        path: 'campaigns',
        loadComponent: () => import('./features/admin/campaigns/campaigns.component').then(m => m.CampaignsComponent)
      },
      {
        path: 'notifications',
        loadComponent: () => import('./features/admin/notifications/notifications.component').then(m => m.NotificationsComponent)
      },
      {
        path: 'analytics',
        loadComponent: () => import('./features/admin/analytics/analytics.component').then(m => m.AnalyticsComponent)
      },
      {
        path: 'gestures',
        loadComponent: () => import('./features/admin/gestures/gestures.component').then(m => m.GesturesComponent)
      },
      {
        path: 'modules',
        loadComponent: () => import('./features/admin/modules/modules.component').then(m => m.ModulesComponent),
        canActivate: [superAdminGuard]
      },
      {
        path: 'locales',
        loadComponent: () => import('./features/admin/locales/locales.component').then(m => m.LocalesComponent),
        canActivate: [superAdminGuard]
      },
      {
        path: 'home-screen',
        loadComponent: () => import('./features/admin/home-screen/home-screen.component').then(m => m.HomeScreenComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];


